
// 数字前自动补0
let autoZero = function (num) {
  return num > 9999 ? num : (Array(4).join(0) + num).slice(-4)
}
// 数字使用千分位分隔
let toThousands = function (number, fixed) {
  if (/^-?\d+(\.\d+)?$/.test(number)) { // 判断输入内容是否为整数或小数
    var n = Math.abs(number)
    if (typeof fixed !== 'undefined' && fixed > -1) {
      n = n.toFixed(fixed)
    }
    var reg = /\d{1,3}(?=(\d{3})+$)/g
    var n1 = (n + '').replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) { return s1.replace(reg, '$&,') + s2 })
    return (number < 0 ? '-' : '') + n1
  } else {
    return '0'
  }
}
// 日期格式化
let dateFormat = function (dateS, part) {
  var date
  if (typeof dateS === 'number') { // 时间戳
    date = new Date(dateS)
    date.setHours(date.getHours() - 8)
  } else {
    if (typeof dateS === 'undefined' || dateS === null || dateS === '' || dateS === '-' || dateS.indexOf('0001') >= 0 || dateS.indexOf('1900') >= 0) {
      return '-'
    }
    if (dateS.length > 10) {
      dateS = dateS.replace(/T/, ' ')
    }
    date = new Date(dateS.replace(/-/g, '/'))
  }
  if (date === new Date(1970, 0, 1)) {
    return '-'
  }
  var redate = ''
  part = (part == null) ? 'yyyy-MM-dd HH:mm:ss' : part
  var y = date.getFullYear()
  var M = date.getMonth() + 1
  var d = date.getDate()
  var H = date.getHours()
  var m = date.getMinutes()
  var s = date.getSeconds()
  var MM = (M > 9) ? M : '0' + M
  var dd = (d > 9) ? d : '0' + d
  var HH = (H > 9) ? H : '0' + H
  var mm = (m > 9) ? m : '0' + m
  var ss = (s > 9) ? s : '0' + s
  redate = part.replace('yyyy', y).replace('MM', MM).replace('dd', dd).replace('HH', HH).replace('mm', mm).replace('ss', ss).replace('M', M).replace('d', d).replace('H', H).replace('m', m).replace('s', s)
  return redate
}
let timeText = function (times) {
  let h = parseInt(times / 3600)
  let m = parseInt((times % 3600) / 60)
  let s = times % 60
  let d = parseInt(h / 24)
  h = h % 24
  return (d ? (d + '天') : '') + (h ? (h + '时') : '') + (m ? (m + '分') : '') + (s + '秒')
}
let whether = function (val) {
  return typeof val === 'undefined' ? '-' : (val ? '是' : '否')
}
let isMobile = function (str) {
  return /^1\d{10}/.test(str)
}

export { autoZero, toThousands, dateFormat, timeText, whether, isMobile }



// WEBPACK FOOTER //
// ./src/assets/js/functions.js